import React from 'react';
import { Breadcrumb, BreadcrumbSectionProps, SemanticShorthandCollection } from 'semantic-ui-react';
import InternalOrExternalLink from "../InternalOrExternalLink";

type BreadCrumbsDetails = {
    name: string;
    url: string;
};

type BreadCrumbsArgs = {
    currentBreadcrumbs: BreadCrumbsDetails[];
    currentPageTitle: string;
};

export default function BreadCrumbsView({ currentBreadcrumbs, currentPageTitle }: BreadCrumbsArgs) {
    const sections: SemanticShorthandCollection<BreadcrumbSectionProps> = [
        ...currentBreadcrumbs.map(b => { return { key: b.name, content: <InternalOrExternalLink label={b.name} href={b.url} /> }; }),
        { key: currentPageTitle, content: currentPageTitle, active: true }
    ];

    return (<Breadcrumb icon="right angle"  data-component={BreadCrumbsView.name} sections={sections} />);
}
